import script from "./IdentificationApplicationForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./IdentificationApplicationForm.vue?vue&type=script&lang=ts&setup=true"

import "./IdentificationApplicationForm.vue?vue&type=style&index=0&id=74b5107c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b5107c"]])

export default __exports__